
export const isProduction = Env.FRONTEND_URL === 'https://zfxzfgtgvxvmrongyfuh.leadingquality.com/';
